'use client';
import React, { useState, useEffect } from 'react';
import { getPublicUser } from '@sbt-web/auth';

function LiveRampScript({ Script }) {
    const [didomiIsReady, setDidomiIsReady] = useState(false);
    const sdkUrlLiveramp = `https://launchpad-wrapper.privacymanager.io/3c5ce5a2-4e21-4239-a4a1-b9b684ab1ce3/launchpad-liveramp.js`;
    useEffect(() => {
        const addLiveRampData = () => {
            const email = getPublicUser()?.email;
            if (email) {
                atsenvelopemodule.setAdditionalData({
                    type: 'emailHashes',
                    id: [email],
                });
            }
        };
        window.didomiOnReady = window.didomiOnReady || [];
        window.addEventListener('envelopeModuleReady', addLiveRampData);
        window.didomiOnReady.push(() => {
            setDidomiIsReady(true);
        });
        return () => {
            window.removeEventListener('envelopeModuleReady', addLiveRampData);
        };
    }, []);
    return (React.createElement(React.Fragment, null, didomiIsReady && (React.createElement(Script, { key: sdkUrlLiveramp, src: sdkUrlLiveramp, strategy: "afterInteractive" }))));
}

export { LiveRampScript };
//# sourceMappingURL=index.js.map
